import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';

import { getIsLinkActive } from '../../utils/path';
import { MenuItemBadge } from '../MenuItemBadge/MenuItemBadge';
import { StyledMenuColumnItem } from './MenuItemDropdown.styles';

interface Props {
    item: NavigationItem;
}

export const MenuColumnItem: FC<Props> = ({ item }) => {
    const { url, colorOption, displayOption, title, badge } = item;
    const pathname = usePathname();
    const isActive = url ? getIsLinkActive(url, pathname) : false;

    return (
        <StyledMenuColumnItem
            href={url}
            $colorOption={colorOption}
            $displayOption={displayOption}
            role="menuitem"
            $isActive={isActive}
            data-element="Link"
            data-element-name={title}
            data-element-color-option={colorOption}
        >
            <span>{title}</span>
            {badge && <MenuItemBadge>{badge}</MenuItemBadge>}
        </StyledMenuColumnItem>
    );
};
